export async function joinWaitingRoom({ userId, email, name, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/joinWaitingRoom`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ userId, email, name }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to join waiting room");
  }
  return data;
}
